// extracted by mini-css-extract-plugin
export default {"wrapper":"KWF3wucg_1kp9xuapn3t"};